// CYR ("Customers choose their preferred reward") Win Odds <-> per-outcome weight.
//
// Win Odds = chance of WINNING a reward. The backend lottery
// (RandomizeOutcomesService) uses each outcome's `probability` as its win-weight,
// so the no_outcome row must carry the NO-prize weight (100 - winProbability) and
// the winning outcomes split winProbability evenly. Storing winProbability on the
// no_outcome row instead inverted the odds (PLA-8788). Single source of truth used
// by GameOutcomeWrapper (Win Odds input) and getCampaignPreparedToBeSent (submit)
// so the contract can't drift. — PLA-7677

export const applyWinProbability = (outcomes: any[], winProbability: number): any[] => {
  const list = outcomes || [];
  const winningOutcomes = list.filter(o => o?.identifier !== 'no_outcome');
  const sharePerWinningOutcome =
    winningOutcomes.length > 0 ? winProbability / winningOutcomes.length : 0;
  return list.map(outcome =>
    outcome?.identifier === 'no_outcome'
      ? { ...outcome, probability: 100 - winProbability }
      : { ...outcome, probability: sharePerWinningOutcome }
  );
};

// no_outcome.probability holds the no-prize weight; Win Odds is its complement.
export const deriveWinProbability = (outcomes: any[]): string | undefined => {
  const noOutcomeRow = (outcomes || []).find(o => o?.identifier === 'no_outcome');
  if (noOutcomeRow?.probability == null) return undefined;
  return String(100 - Number(noOutcomeRow.probability));
};
